import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { ProviderNameText } from '../TextStyles/ProviderNameText';
import { ColumnSecondaryText } from '../TextStyles/ColumnSecondaryText';

interface OwnProps {
  /**
   * Name of car rental provider
   *
   * @example
   * "Hertz Corporation"
   */
  providerName: string;
  carCategory?: string;
}

interface CarProviderDetailsProps extends OwnProps {}

const CarProviderDetailsBase: FunctionComponent<CarProviderDetailsProps> = ({
  providerName,
  carCategory,
}) => {
  return (
    <>
      <ProviderNameText>{providerName}</ProviderNameText>
      {carCategory && <ColumnSecondaryText>{carCategory}</ColumnSecondaryText>}
    </>
  );
};

/**
 * Car provider details
 *
 * @example
 * "Hertz Corporation"
 */
export const CarProviderDetails = pure(CarProviderDetailsBase);

CarProviderDetails.displayName = 'CarProviderDetails';
